import {
  parsePhoneNumberFromString,
  getCountryCallingCode
} from "libphonenumber-js";

export default function validatePhoneNumberWithCountry(
  value = "",
  expectedCountry,
  nullable
) {
  try {
    if (nullable && value === "") return true;

    const phone = parsePhoneNumberFromString(value, expectedCountry);
    if (!phone || !phone.isValid()) return false;

    const expectedCallingCode = getCountryCallingCode(expectedCountry);
    return phone.countryCallingCode === expectedCallingCode;
  } catch {
    return false;
  }
}
